/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S8_HeadingInputs */

const tr_servis_s8_heading = /** @type {(inputs: Servis_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Güvenlik Olayları ve İhbar`)
};

const en_servis_s8_heading = /** @type {(inputs: Servis_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Security Incidents and Notification`)
};

const de_servis_s8_heading = /** @type {(inputs: Servis_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Sicherheitsvorfälle und Meldung`)
};

const ru_servis_s8_heading = /** @type {(inputs: Servis_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Инциденты безопасности и уведомление`)
};

/**
* | output |
* | --- |
* | "8. Security Incidents and Notification" |
*
* @param {Servis_S8_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s8_heading = /** @type {((inputs?: Servis_S8_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S8_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s8_heading(inputs)
	if (locale === "de") return de_servis_s8_heading(inputs)
	if (locale === "ru") return ru_servis_s8_heading(inputs)
	return tr_servis_s8_heading(inputs)
});